import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import {
    BulkAction,
    GetCustomerListQuery,
    ItemOf,
} from '@vendure/admin-ui/core';
import { CustomersActiveListComponent } from './customers-active-list.component';

export const reTargetCustomerBulkAction: BulkAction<
    ItemOf<GetCustomerListQuery, 'customers'>,
    CustomersActiveListComponent
> = {
    location: 'customers-active-list',
    label: 'Re Target',
    icon: 'target',
    onClick: ({ injector, selection, hostComponent, clearSelection }) => {
        const customerIDs = selection.map(item => item.id);
        window.open(
            `/admin/extensions/deals/create?customerIds=${customerIDs.join(',')}`,
            '_blank',
        );
    },
};